import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCard = ({ product }) => {
  return (
    <motion.div 
      className="bg-slate-50 rounded p-3 shadow-md"
      initial={{ opacity: 0, x: -50 }} // Start from left and transparent
      whileInView={{ opacity: 1, x: 0 }} // Animate to normal position
      transition={{ duration: 1.2 }} // Duration of the animation
      viewport={{ once: true }} // Animate only once when in view
    >
      <div className="flex flex-col md:text-left md:items-start">
        <motion.div 
          className="h-44 w-full"
          initial={{ opacity: 0, x: -100 }} // Image specific animation
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }} // Delay for staggered effect
          viewport={{ once: true }}
          whileHover={{ scale: 1.3 }} // Add hover effect
        >
          <img 
            src={product.images[0]} 
            alt={product.name} 
            className="w-full h-full md:w-64 lg:w-72 object-contain" 
          />
        </motion.div>
        <div className="mt-4">
          <h3 className="text-xl md:text-2xl font-semibold text-gray-900 capitalize">
            {product.name}
          </h3>
          <p className="text-gray-600">
            {product.description}
          </p>
          <Link 
            to={`/product/${product.id}`} 
            className="text-blue-600 hover:underline mt-2 inline-block"
          >
            More about {product.name} &rarr;
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
